import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiGetOrganizationChartDepartmentsRequest,
  DefaultApiGetOrganizationChartEmployeesRequest,
  DefaultApiGetOrganizationChartRolesRequest,
  DefaultApiParseOrganizationChartForWorkflowRequest,
  DefaultApiRegisterOrganizationChartForWorkflowRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const getOrganizationChartDepartments = async (
  instance: AxiosInstance,
  params: DefaultApiGetOrganizationChartDepartmentsRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getOrganizationChartDepartments(params)
}

export const getOrganizationChartEmployees = async (
  instance: AxiosInstance,
  params: DefaultApiGetOrganizationChartEmployeesRequest
) => {
  return await userApiDefaultApiFactory(instance).getOrganizationChartEmployees(
    params
  )
}

export const getOrganizationChartRoles = async (
  instance: AxiosInstance,
  params: DefaultApiGetOrganizationChartRolesRequest
) => {
  return await userApiDefaultApiFactory(instance).getOrganizationChartRoles(
    params
  )
}

export const parseOrganizationChartForWorkflow = async (
  instance: AxiosInstance,
  params: DefaultApiParseOrganizationChartForWorkflowRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).parseOrganizationChartForWorkflow(params)
}

export const registerOrganizationChartForWorkflow = async (
  instance: AxiosInstance,
  params: DefaultApiRegisterOrganizationChartForWorkflowRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).registerOrganizationChartForWorkflow(params)
}

// Do Not Remove this line ===@import api client===
